import { Input } from '@use-ui/bootstrap3'
import { useForm } from '@use-ui/hooks'
import * as React from 'react'
import { Button } from '../Button/Button'
import { FormError } from '../Forms/FormError'
import { loginService } from '../../services/authx'

type LoginFields = {
  username: string;
  password: string;
};

type Props = { login(tokens): Promise<void> };

export function Login (props: Props) {
  const form = useForm<LoginFields>()

  const login = form.action(async (data) => {
    const tokens = await loginService(data)
    await props.login(tokens)
  })

  return (
    <div style={{ maxWidth: 500 }}>
      <div className="top-panel">
        <form>
          <div className="top-panel-title">Login</div>

          <FormError>{form.error}</FormError>

          <div className="data-form">
            <Input label="Username" field={form.fields.username} />
            <Input label="Password" field={form.fields.password} inputType="password" />
          </div>

          <Button type="submit" onClick={login} disabled={login.progress}>
            Login
          </Button>
        </form>
      </div>
    </div>
  )
}
